import React, { useEffect, useState } from "react";
import axios from "axios";

import styled from "styled-components";

import { Spin, Table, Button } from "antd";
import { handleError } from "../../../modules/presence/sagas";
import { getServicesApi } from "../../../redux/sagas/userSagas";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";

const Services = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [reload, setReload] = useState(false);

  const fetchServices = async () => {
    setIsLoading(true);
    try {
      const data = await getServicesApi({ match: { scope: { $ne: "Tablette" } } });
      setData(data);
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, [reload]);

  const handleActivation = async (record, activationStatus) => {
    setIsLoading(true);
    try {
      await axios.post(
        `${baseapi}/services/${record.id}`,
        { isActivated: activationStatus },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setReload(!reload);
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };
  const columns = [
    {
      title: "Services",
      dataIndex: "id",
      key: "id",
      render: id => {
        return <span>{id}</span>;
      }
    },
    {
      title: "Services",
      dataIndex: "label",
      key: "label",
      render: label => {
        return <span>{label}</span>;
      }
    },
    {
      title: "Services",
      dataIndex: "scope",
      key: "scope",
      render: scope => {
        return <span>{scope}</span>;
      }
    },
    {
      title: "Activé ? ",
      dataIndex: "isActivated",
      key: "isActivatedStatus",
      render: isActivated => {
        return <span>{`${isActivated ? "OUI" : "NON"}`}</span>;
      }
    },
    {
      title: "Action",
      key: "isActivatedAction",
      render: (text, record) => (
        <div>
          <Button
            disabled={isLoading || record.isActivated}
            className="p-content-page-center-header-buttons-item"
            style={{ background: record.isActivated ? "#dddddd" : "#52c41a" }}
            onClick={() => handleActivation(record, true)}
          >
            Activer
          </Button>
          <Button
            disabled={isLoading || !record.isActivated}
            className="p-content-page-center-header-buttons-item"
            style={{ background: record.isActivated ? "#f5222d" : "#dddddd" }}
            onClick={() => handleActivation(record, false)}
          >
            Désactiver
          </Button>
        </div>
      )
    }
  ];

  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30, width: "30%" }}>{`Services à activer ou désactiver`}</div>
        </div>
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
        )}
      </React.Fragment>
    </Container>
  );
};

export default Services;



// WEBPACK FOOTER //
// src/pages/admin/services/Services.js